import {FC, ReactNode} from 'react';
import {BackendProvider, BackendProviderProps} from './backend';
import LocaleProvider from './locale';
import ReactQuery, {ReactQuerySettings} from './query';

export type StateProps = BackendProviderProps & {
    children: ReactNode;
    rq?: ReactQuerySettings;
};

const State: FC<StateProps> = ({
    appPermissions,
    children,
    data,
    flags,
    messages,
    rq,
}) => (
    <ReactQuery {...rq}>
        <LocaleProvider>
            <BackendProvider
                appPermissions={appPermissions}
                data={data}
                flags={flags}
                messages={messages}
            >
                {children}
            </BackendProvider>
        </LocaleProvider>
    </ReactQuery>
);

export default State;
